import { AlertTriangle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface ClinicalTrialBannerProps {
  variant?: "fixed" | "inline";
}

/**
 * Regulatorischer Warnhinweis für die US-Domain (eap-abutments.us).
 * Wortlaut nach 21 CFR 812.5(a) – FDA Investigational Device Labeling.
 * Nicht ausblendbar: ein regulatorischer Warnhinweis darf vom Nutzer
 * nicht entfernt werden können (FDA-Compliance / MDR Art. 7).
 */
export const ClinicalTrialBanner = ({
  variant = "fixed",
}: ClinicalTrialBannerProps) => {
  const { isUSDomain } = useLanguage();

  if (!isUSDomain) {
    return null;
  }

  const wrapperClass =
    variant === "fixed"
      ? "fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-amber-950 border-b-2 border-amber-700"
      : "w-full bg-amber-500 text-amber-950 border-y-2 border-amber-700";

  return (
    <div className={wrapperClass} role="alert" aria-live="polite">
      <div className="container mx-auto px-4 py-2.5">
        <div className="flex items-start sm:items-center justify-center gap-3 text-center">
          <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5 sm:mt-0" aria-hidden="true" />
          <p className="text-xs sm:text-sm font-semibold leading-snug">
            CAUTION — Investigational Device. Limited by United States federal law to investigational use.
            Not cleared or approved by the U.S. FDA. Not for sale in the United States.
          </p>
        </div>
      </div>
    </div>
  );
};
